import * as React from "react";

const IasConference = () => {
  return (
    <ol className="references">
      <li>
        HIV.gov website. Why do people with HIV need stable housing? Accessed
        July 20, 2022. <br className="d-block d-md-none" />
        <a
          target="_blank"
          className=""
          href="https://www.hiv.gov/hiv-basics/living-well-with-hiv/taking-care-of-yourself/housing-and-health"
        >
          https://www.hiv.gov/hiv-basics/living-well-with-hiv/taking-care-of-yourself/housing-and-health
        </a>
      </li>
      <li>
        Conyers L, Chiu JY, Rueda S, Misrok M, Lynn V, McKinney-Prupis E.
        Employment as a social determinant of HIV care and prevention outcomes.
        In: Okaware SI, ed.{" "}
        <i>AIDS Updates: Recent Advances and New Perspectives.</i> Accessed July
        18, 2022.&nbsp;
        <br className="d-block d-md-none" />
        <a
          target="_blank"
          className=""
          href="https://doi.org/10.5772/intechopen.98418"
        >
          https://doi.org/10.5772/intechopen.98418
        </a>
      </li>
      <li>
        The syndemic threat of food insecurity and HIV. <i>Lancet</i>.
        2020;7(2):e75.
        <br className="d-block d-md-none" />
      </li>
      <li>
        Barr A, Shiro AG, Perry AM. The pandemic showed why social and
        structural determinants of health matter. Now it’s time for policymakers
        to act. February 18, 2022. Accessed July 20, 2022.&nbsp;
        <br className="d-block d-md-none" />
        <a
          target="_blank"
          className=""
          href="https://www.brookings.edu/blog/how-we-rise/2022/02/18/the-pandemic-showed-why-social-and-structural-determinants-of-health-matter-now-its-time-for-policymakers-to-act/"
        >
          https://www.brookings.edu/blog/how-we-rise/2022/02/18/the-pandemic-showed-why-social-and-structural-determinants-of-health-matter-now-its-time-for-policymakers-to-act/
        </a>
      </li>
      <li>
        Greene S, McCargo A. New data suggest COVID-19 is widening housing
        disparaties by race and income. May 29, 2020. Accessed July 20,
        2022.&nbsp;
        <br className="d-block d-md-none" />
        <a
          target="_blank"
          className=""
          href="https://www.urban.org/urban-wire/new-data-suggest-covid-19-widening-housing-disparities-race-and-income"
        >
          https://www.urban.org/urban-wire/new-data-suggest-covid-19-widening-housing-disparities-race-and-income
        </a>
      </li>
      <li>
        Spievack N, González-Hermoso J, Brown S. Latinx unemployment is highest
        of all racial and ethnic groups for the firsttime on record. May 8,
        2020. Accessed July 20, 2022.&nbsp;
        <br className="d-block d-md-none" />
        <a
          target="_blank"
          className=""
          href="https://www.urban.org/urban-wire/latinx-unemployment-highest-all-racial-and-ethnic-groups-first-time-record"
        >
          https://www.urban.org/urban-wire/latinx-unemployment-highest-all-racial-and-ethnic-groups-first-time-record
        </a>
      </li>
      <li>
        Tomlinson H. CDC on the frontlines: transforming the HIV epidemic in the
        midst of the COVID-19 pandemic. March 8, 2022. Accessed July 20,
        2022.&nbsp;
        <br className="d-block d-md-none" />
        <a
          target="_blank"
          className=""
          href="https://www.cdc.gov/globalhivtb/who-we-are/leadership/statements/2022/leadershipstatement-apr-2022.html"
        >
          https://www.cdc.gov/globalhivtb/who-we-are/leadership/statements/2022/leadershipstatement-apr-2022.html
        </a>
      </li>
      {/* <li>
        Eisinger RW, Lerner AM, Fauci AS. Human immunodeficiency virus/AIDS in
        the era of coronavirus disease 2019: a juxtaposition of 2 pandemics. J
        Infect Dis. 2021;224(9):1455-1461.
      </li>
      <li>
        Tomlinson H. CDC on the frontlines: transforming the global HIV epidemic
        in the midst of the COVID-19 pandemic. Published March 8, 2022. Accessed
        June 30, 2022.&nbsp;
        <a
          target="_blank"
          className=""
          href="https://www.hiv.gov/blog/cdc-frontlines-transforming-global-hiv-epidemic-midst-covid-19-pandemic"
        >
          https://www.hiv.gov/blog/cdc-frontlines-transforming-global-hiv-epidemic-midst-covid-19-pandemic
        </a>
      </li>
      <li>
        Heck M. Effect of the COVID-19 pandemic on outcomes of HIV care, mental
        health. Published March 15, 2022. Accessed June 30, 2022. <br />
        <a
          target="_blank"
          className=""
          href="https://www.infectiousdiseaseadvisor.com/home/topics/hiv-aids/covid-19-decreased-hiv-care-increased-mental-health-visits/"
        >
          https://www.infectiousdiseaseadvisor.com/home/topics/hiv-aids/covid-19-decreased-hiv-care-increased-mental-health-visits/
        </a>
      </li>
      <li>
        Barr A, Shira AG, Perry AM. The pandemic showed why social and
        structural determinants of health matter. Now it’s time for policymakers
        to act. Published February 18, 2022. Accessed June 30, 2022.&nbsp;
        <a
          target="_blank"
          className=""
          href="https://www.brookings.edu/blog/how-we-rise/2022/02/18/the-pandemic-showed-why-social-and-structural-determinants-of-health-matter-now-its-time-for-policymakers-to-act/"
        >
          https://www.brookings.edu/blog/how-we-rise/2022/02/18/the-pandemic-showed-why-social-and-structural-determinants-of-health-matter-now-its-time-for-policymakers-to-act/
        </a>
      </li> */}
    </ol>
  );
};

export default IasConference;
